import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Question } from '../models/question.model';
import { QuestionsApi } from '../api/questions.api';

@Injectable({ providedIn: 'root' })
export class QuestionsService {
  private readonly _api = inject(QuestionsApi);

  public getQuestions(
    search: string,
    categories: string,
  ): Observable<Question[]> {
    return this._api.getQuestions(search, categories);
  }
}
